import React, { JSX } from 'react';

// Types
import { StockFilterOption } from '../../../types/Stock';
import { DataValues } from '../../../types/Settings';

// Components
import StockCarrierFilter from './StockCarrierFilter';
import StockStationFilter from './StockStationFilter';
import StockEquipmentTypeFilter from './StockEquipmentTypeFilter';
import StockUldTypeFilter from './StockUldTypeFilter';
import StockUldCategoryFilter from './StockUldCategoryFilter';
import { SearchableOption } from './stockDetails.constants';

interface StockFiltersBarProps {
  carrierId: string;
  carrierOptions: SearchableOption[];
  isExternalUser: boolean;
  noCarrierAssigned: boolean;

  stationId: string;
  stationInputValue: string;
  stationOptions: SearchableOption[];
  stationSearching: boolean;
  onStationInputValueChange: (value: string) => void;
  onStationSelect: (stationId: string, selectedOption: SearchableOption) => void;

  equipmentType: string | undefined;
  equipmentTypeOptions: DataValues[] | undefined;
  onEquipmentTypeChange: (value: string | undefined) => void;

  uldCategory: string | undefined;
  uldCategoryOptions: DataValues[] | undefined;
  onUldCategoryChange: (value: string | undefined) => void;

  uldGroupId: string;
  uldTypeOptions: StockFilterOption[];

  onApplyFilters: (nextCarrierId: string, nextUldGroupId: string) => void;
}

export default function StockFiltersBar({
  carrierId,
  carrierOptions,
  isExternalUser,
  noCarrierAssigned,
  stationId,
  stationInputValue,
  stationOptions,
  stationSearching,
  onStationInputValueChange,
  onStationSelect,
  equipmentType,
  equipmentTypeOptions,
  onEquipmentTypeChange,
  uldCategory,
  uldCategoryOptions,
  onUldCategoryChange,
  uldGroupId,
  uldTypeOptions,
  onApplyFilters,
}: StockFiltersBarProps): JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        marginBottom: 10,
        marginLeft: 5,
      }}
    >
      <StockCarrierFilter
        carrierId={carrierId}
        carrierOptions={carrierOptions}
        isExternalUser={isExternalUser}
        noCarrierAssigned={noCarrierAssigned}
        onChange={(nextCarrierId) => onApplyFilters(nextCarrierId, uldGroupId)}
      />
      <StockStationFilter
        stationId={stationId}
        stationInputValue={stationInputValue}
        options={stationOptions}
        loading={stationSearching}
        onInputValueChange={onStationInputValueChange}
        onSelect={onStationSelect}
      />
      <StockEquipmentTypeFilter value={equipmentType} options={equipmentTypeOptions} onChange={onEquipmentTypeChange} />
      <StockUldCategoryFilter value={uldCategory} options={uldCategoryOptions} onChange={onUldCategoryChange} />
      <StockUldTypeFilter value={uldGroupId} options={uldTypeOptions} onChange={(nextUldGroupId) => onApplyFilters(carrierId, nextUldGroupId)} />
    </div>
  );
}
